

























































































import { Component, Prop, VModel } from 'vue-property-decorator'

import { PropertyFieldType } from '../../../../../BotProperties/components/Properties/types'
import { UserProfileConfig } from '../../../../../BotUserProfile/types'
import { UserProfileProperty } from '../../../../../BotUsers/components/Users/types'
import UploadMediaDescriptors from '../../../../../MediaUploader/UploadMediaDescriptors.vue'
import { UseFields } from '../../../../../Pi'
import { FieldData } from '../../../../../Pi/types'
import Picker from '../../../../../Picker/Picker.vue'
import { PickerFormat } from '../../../../../Picker/types'

@Component({
  data() {
    return {
      PropertyFieldType,
    }
  },
  components: {
    UploadMediaDescriptors,
    Picker,
  }
})
export default class SetUserPropertyField extends UseFields {
  @VModel() propValue!: UserProfileProperty['value'] | null

  @Prop() mediaTargetId!: UserProfileConfig['mediaTargetId']

  @Prop() propertyType!: PropertyFieldType | null

  @Prop() targetProperty!: any

  get context(): SetUserPropertyField {
    return this
  }

  get pickerFormat(): PickerFormat | null {
    if (this.propertyType === PropertyFieldType.Time) {
      return PickerFormat.Time
    } else if (this.propertyType === PropertyFieldType.Date) {
      return PickerFormat.Date
    } else if (this.propertyType === PropertyFieldType.DateTime) {
      return PickerFormat.DateTime
    }

    return null
  }

  setModel(arg: FieldData): FieldData {
    arg.setter = (val) => this.propValue = val

    return arg
  }

  setNumberValue(arg: FieldData): FieldData {
    arg.setter = (val) => {
      if (this.propertyType === PropertyFieldType.Double) {
        this.propValue = val
      } else {
        if (Number.isInteger(val)) {
          this.propValue = val
        } else {
          this.propValue = Math.round(val)
        }
      }
    }
    return arg
  }

}
